import { render, staticRenderFns } from "./clientArea.vue?vue&type=template&id=002d89c0&"
import script from "./clientArea.vue?vue&type=script&lang=js&"
export * from "./clientArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports